import ClipboardImage from '../../images/clipboardv2.png';
import { Box, Button, Image, Page, Text } from '@zillow/constellation-10';
import { Link } from 'react-router-dom';
import { manifest } from '../../app/routes';
import { useAppGuestPay } from '../../hooks/useGuestPay';

export const GuestPayNoInvoicesPage = () => {
  const { guestPayState } = useAppGuestPay();

  return (
    <Page.Content>
      <Box
        css={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '250px',
        }}
      >
        <Box css={{ marginTop: 'xl' }}>
          <Image src={ClipboardImage} alt="Payment confirmation" css={{ height: '250px', paddingTop: 'lg' }} />
        </Box>
        <Text textStyle="heading-xl" css={{ marginBottom: 'md' }}>
          There are no invoices due for {guestPayState.accountNumber}
        </Text>
        <Text>Return to guest payments to pay a different invoice.</Text>
        <Box>
          <Button asChild css={{ marginTop: 'md' }} tone="neutral" emphasis="outlined">
            <Link to={manifest.guestPayPage}>Go to guest payments</Link>
          </Button>
        </Box>
      </Box>
    </Page.Content>
  );
};
